import { render, staticRenderFns } from "./ManageSkinUsage.vue?vue&type=template&id=720724cc&scoped=true"
import script from "./ManageSkinUsage.vue?vue&type=script&lang=js"
export * from "./ManageSkinUsage.vue?vue&type=script&lang=js"
import style0 from "./ManageSkinUsage.vue?vue&type=style&index=0&id=720724cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720724cc",
  null
  
)

export default component.exports